var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 192H64C28.654 192 0 220.654 0 256V352C0 369.674 14.326 384 32 384H64V480C64 497.674 78.326 512 96 512H416C433.674 512 448 497.674 448 480V384H480C497.674 384 512 369.674 512 352V256C512 220.654 483.346 192 448 192ZM384 448H128V352H384V448ZM432 296C418.75 296 408 285.25 408 272C408 258.734 418.75 248 432 248S456 258.734 456 272C456 285.25 445.25 296 432 296ZM128 64H357.49L384 90.51V160H448V77.25C448 68.766 444.625 60.625 438.625 54.625L393.375 9.375C387.375 3.375 379.219 0 370.75 0H96C78.344 0 64 14.328 64 32V160H128V64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a77b90858c4726161813b1a3f684907f.svg";
export { ForwardRef as ReactComponent };